import React, { useState, useEffect } from 'react';
import postMessage from '../../post-message/PostMessageUtils';
import { defaultTenant } from '../AlmeTenantSelector/AlmeTenants';
import { defaultTestPageState, getTestPageState } from '../AlmeTestPage/AlmeTestPageState';
import MessageType from '../../post-message/MessageType';
import LaunchIconButton from './LaunchIconButton';
import { getCurrentAppState } from '../AlmeApp/AlmeAppState';
import { isTestPage } from '../../utils/resourceUtils';
import { CommonElementId } from '../Common/constants';
export function canShowLaunchPointIcon(appConfig, isChatOpen, historyLoaded) {
    var _a;
    return appConfig.main.showIvaChatIcon && !isChatOpen && historyLoaded && !!((_a = window.NITGlobal) === null || _a === void 0 ? void 0 : _a.clientAvailable);
}
export function renderLaunchPointIcon(appConfig, isHistoryLoaded, hasHistory, isChatOpen) {
    return (canShowLaunchPointIcon(appConfig, isChatOpen, isHistoryLoaded)
        ? React.createElement(AlmeLaunchPoint, { isTestPage: isTestPage(appConfig.webUrl), isMinimized: !isChatOpen && hasHistory, zIndex: (appConfig.zIndex) })
        : null);
}
export function getLaunchPointParams(isTestSite) {
    if (isTestSite) {
        const testPageState = getTestPageState();
        if (testPageState) {
            return testPageState.launchSettings;
        }
    }
    return defaultTestPageState.launchSettings;
}
const AlmeLaunchPoint = (props) => {
    const [message, setMessage] = useState(null);
    useEffect(() => {
        if (message) {
            postMessage(message);
        }
    }, [message]);
    const handleClick = () => {
        const launchPointParams = getLaunchPointParams(props.isTestPage);
        const appState = getCurrentAppState();
        setMessage({
            type: MessageType.LaunchIva,
            launchPointName: launchPointParams.launchPointName,
            launchParameter: launchPointParams.launchParameter,
            source: 'client',
            accessKey: appState.accessKey || defaultTenant.value,
        });
    };
    return (React.createElement(LaunchIconButton, { id: CommonElementId.AlmeLaunchButton, dataReason: "ivachat", dataType: "ivachat-icon", "data-testid": "launchIvaBtn", dataAnalytics: "clicktrackingevent", dataObject: "button", className: "ensightencustomevent", onClick: handleClick, zIndex: props.zIndex, isMinimized: props.isMinimized }));
};
export default AlmeLaunchPoint;
